import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "flex flex-col items-center p-8 space-y-6"
};
const _hoisted_2 = {
  key: 2,
  class: "text-gray-600 text-sm text-center"
};
const _hoisted_3 = {
  class: "flex justify-between px-6 py-4"
};
const _hoisted_4 = {
  class: "px-8 py-6"
};
const _hoisted_5 = {
  class: "flex flex-col justify-center p-4"
};
const _hoisted_6 = {
  class: "px-8 py-6"
};
import { ref, onMounted, nextTick } from 'vue';
import { storeToRefs } from 'pinia';
import { useMeStore } from '@/services/UserService/useMeStore';
import LlSwitch from '@/components/LlSwitch.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import M356Logo from '@/components/SVG/M356Logo.vue';
import LLLogo from '@/components/SVG/LLLogo.vue';
import { useEntriesStore } from '@/services/useEntriesStore';
export default {
  __name: 'M365Integration',
  setup(__props) {
    const entriesStore = useEntriesStore();
    const meStore = useMeStore();
    const enabled = ref(false);
    const switchValue = ref(false);
    const showDisableDialog = ref(false);
    const loading = ref(true);
    const {
      features
    } = storeToRefs(meStore);
    const updateM365Status = async () => {
      const {
        m365
      } = (await entriesStore.externalEventsStatus()) || {};
      enabled.value = !!m365;
      switchValue.value = enabled.value;
    };
    onMounted(async () => {
      loading.value = true;
      await meStore.getMe();
      if (features.value?.m365) {
        await updateM365Status();
      }
      loading.value = false;
    });
    const toggleM365 = async value => {
      if (!features.value?.m365) return;
      if (value) {
        loading.value = true;
        await entriesStore.enableMicrosoft();
        await updateM365Status();
      } else {
        showDisableDialog.value = true;
        nextTick(() => {
          switchValue.value = enabled.value;
        });
      }
    };
    const confirmDisable = async () => {
      loading.value = true;
      await entriesStore.disableM365();
      await updateM365Status();
      showDisableDialog.value = false;
      loading.value = false;
    };
    const dialogUpdated = val => {
      showDisableDialog.value = val;
      if (!val) {
        switchValue.value = enabled.value;
      }
    };
    return (_ctx, _cache) => {
      const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_spacer = _resolveComponent("v-spacer");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_dialog = _resolveComponent("v-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(M356Logo, {
        class: "w-20 h-20",
        "aria-label": "Microsoft 365 Logo"
      }), _cache[11] || (_cache[11] = _createElementVNode("h2", {
        class: "text-xl font-semibold"
      }, "Microsoft 365 Integration", -1)), _cache[12] || (_cache[12] = _createElementVNode("p", {
        class: "text-gray-600 text-sm text-center max-w-md"
      }, " Integrate LeanLaw with Microsoft 365 to receive calendar events and add them to LeanLaw as time entries. Save time and enjoy a synchronized experience across commonly-used tools. ", -1)), loading.value ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
        key: 0,
        type: "button",
        width: "175",
        height: "24",
        class: "my-2"
      })) : _unref(features).m365 ? (_openBlock(), _createBlock(LlSwitch, {
        key: 1,
        modelValue: switchValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => switchValue.value = $event),
        onChange: toggleM365,
        label: "Enable Microsoft 365"
      }, null, 8, ["modelValue"])) : (_openBlock(), _createElementBlock("p", _hoisted_2, " Microsoft 365 integration is not available for your account. Please contact LeanLaw support for more information. ")), _createVNode(_component_v_dialog, {
        modelValue: showDisableDialog.value,
        "onUpdate:modelValue": [_cache[4] || (_cache[4] = $event => showDisableDialog.value = $event), dialogUpdated],
        width: "552"
      }, {
        default: _withCtx(() => [_createVNode(_component_v_card, {
          class: "px-4"
        }, {
          append: _withCtx(() => [_createVNode(LlSecondaryButton, {
            icon: "mdi-close",
            variant: "text",
            size: "small",
            "aria-label": "Close",
            onClick: _cache[1] || (_cache[1] = _withModifiers($event => showDisableDialog.value = false, ["prevent"]))
          })]),
          default: _withCtx(() => [_cache[10] || (_cache[10] = _createElementVNode("div", {
            class: "text-center text-2xl font-semibold"
          }, "Disable Microsoft 365", -1)), _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_v_card, {
              class: "elevation-2 transition-swing rounded-md"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(LLLogo)])]),
              _: 1
            }), _createElementVNode("div", _hoisted_5, [_createVNode(_component_v_icon, {
              size: "40"
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("mdi-close-circle", -1)]))]),
              _: 1
            })]), _createVNode(_component_v_card, {
              class: "elevation-2 transition-swing rounded-md"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(M356Logo)])]),
              _: 1
            })]), _cache[6] || (_cache[6] = _createElementVNode("div", {
              class: "text-center px-12 py-2"
            }, " This will revoke all permissions and authorisations for the Microsoft 365 app. ", -1)), _cache[7] || (_cache[7] = _createElementVNode("div", {
              class: "text-center font-medium px-8 py-2"
            }, " Are you sure you want to disable Microsoft 365? ", -1))]),
            _: 1
          }), _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [_createVNode(_component_v_spacer), _createVNode(LlSecondaryButton, {
              variant: "outlined",
              size: "small",
              onClick: _cache[2] || (_cache[2] = _withModifiers($event => showDisableDialog.value = false, ["prevent"]))
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode(" Skip ", -1)]))]),
              _: 1
            }), _createVNode(LlSecondaryButton, {
              variant: "flat",
              size: "small",
              color: "error",
              class: "mr-2",
              onClick: _cache[3] || (_cache[3] = _withModifiers($event => confirmDisable(), ["prevent"]))
            }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode(" Disable ", -1)]))]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};